import {
  LightboxService,
  PhotoSwipeItem,
} from "features/gallery/lightbox/lightbox.service"
import { getGalleryMedia } from "features/posts/gallery/gallery.functions"
import { getContextName, ViewContext } from "concerns/useContextName"
import { GroupMember } from "suus-api"

export const usePostMediaPhotoswipe = (
  postId: number,
  postMediaCount: number,
  lightboxService: LightboxService,
  viewContext: ViewContext
) => {
  const loadMedium = async (index: number): Promise<PhotoSwipeItem> => {
    const media = await getGalleryMedia(postId, index, 1)
    const originalFile = media[0]?.uploaded_file.original

    const author: GroupMember = media[0]?.uploaded_file.uploaded_by
    const contextAuthorName = getContextName(viewContext, author)

    return {
      src: originalFile.url,
      width: originalFile.width,
      height: originalFile.height,
      authorName: contextAuthorName,
    }
  }

  const openLightbox = (index: number) => {
    lightboxService.openPhotoLightbox(index, postMediaCount, loadMedium)
  }

  return {
    openLightbox,
  }
}
